import script from "./TitleElm.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleElm.vue?vue&type=script&setup=true&lang=js"

import "./TitleElm.vue?vue&type=style&index=0&id=2ac3d496&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac3d496"]])

export default __exports__